import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../views/Home.vue";
import LocalStorageService from "@/services/LocalStorageService";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { requiresAuth: true, scopes: ["admin"] },
  },
  {
    path: "/correction",
    name: "correction",
    redirect: { name: "correction_view" },
    component: () =>
      import(
        /* webpackChunkName: "manage" */ "../views/Correction/CorrectionIndex.vue"
      ),
    children: [
      {
        path: "view",
        name: "correction_view",
        component: () => import("../views/Correction/Correction.vue"),
        meta: { requiresAuth: true, scopes: ["admin", "verifier"] },
      },
      {
        path: "reports",
        name: "correction_reports",
        component: () => import("../views/Correction/CorrectionReports.vue"),
        meta: { requiresAuth: true, scopes: ["admin", "verifier"] },
      },
    ],
  },
  {
    path: "/dictionary",
    name: "dictionary",
    redirect: { name: "search" },
    component: () =>
      import(
        /* webpackChunkName: "manage" */ "../views/VerifierDictionary/DictionaryIndex.vue"
      ),
    meta: { requiresAuth: true, scopes: ["admin", "verifier"] },
    children: [
      {
        path: "search",
        name: "search",
        component: () => import("../views/VerifierDictionary/Dictionary.vue"),
        meta: { requiresAuth: true, scopes: ["admin", "verifier"] },
      },
    ],
  },
  {
    path: "/manage",
    name: "manage",
    component: () =>
      import(/* webpackChunkName: "manage" */ "../views/manage/index.vue"),
    redirect: { name: "users-list" },
    meta: { requiresAuth: true, scopes: ["admin"] },
    children: [
      {
        path: "tarif",
        name: "tarif",
        component: () =>
          import(/* webpackChunkName: "tarif" */ "../views/manage/tarif"),
        meta: { requiresAuth: true, scopes: ["admin"] },
        children: [
          {
            path: ":tarif_id",
            name: "tariff-item",
            component: () =>
              import(
                /* webpackChunkName: "tarifItem" */ "../views/manage/createTarifForm.vue"
              ),
            props: true,
            meta: { requiresAuth: true, scopes: ["admin"] },
          },
        ],
      },
      {
        path: "users",
        name: "users-list",
        component: () =>
          import(
            /* webpackChunkName: "users-list" */ "../views/manage/UsersList.vue"
          ),
        meta: { requiresAuth: true, scopes: ["admin"] },
        children: [
          {
            path: ":userId",
            name: "user-view",
            component: () =>
              import(
                /* webpackChunkName: "users-list" */ "../views/manage/UserView.vue"
              ),
            props: true,
            meta: { requiresAuth: true, scopes: ["admin"] },
          },
        ],
      },
      {
        path: "settings",
        name: "settings",
        component: () => import("../views/manage/Settings.vue"),
        meta: { requiresAuth: true, scopes: ["admin"] },
        children: [
          {
            path: "batches",
            name: "batches",
            component: () => import("../views/manage/FileBatchesSettings.vue"),
            props: true,
            meta: { requiresAuth: true, scopes: ["admin"] },
          },
          {
            path: "upload",
            name: "upload",
            component: () => import("../views/manage/FileUploadSettings.vue"),
            props: true,
            meta: { requiresAuth: true, scopes: ["admin"] },
          },
          {
            path: "unload",
            name: "unload",
            component: () => import("../views/manage/FileUnloadSettings.vue"),
            props: true,
            meta: { requiresAuth: true, scopes: ["admin"] },
          },
        ],
      },
      {
        path: "reports",
        name: "reports",
        component: () => import("../views/manage/Reports/ReportsIndex.vue"),
        meta: { requiresAuth: true, scopes: ["admin"], showChildren: true },
        redirect: { name: "summary_reports" },
        children: [
          {
            path: "summary_reports",
            name: "summary_reports",
            title: "Сводный",
            component: () =>
              import("../views/manage/Reports/SummaryReportsList.vue"),
            meta: { requiresAuth: true, scopes: ["admin"] },
          },
          {
            path: "annotator_reports",
            name: "annotator_reports",
            title: "Аннотаторы",
            component: () =>
              import("../views/manage/Reports/AnnotatorsReportsList.vue"),
            meta: { requiresAuth: true, scopes: ["admin"] },
          },
          {
            path: "marked_reports",
            name: "marked_reports",
            title: "Размеченные файлы",
            component: () =>
              import("../views/manage/Reports/MarkedFilesReportsList.vue"),
            meta: { requiresAuth: true, scopes: ["admin"] },
          },
          {
            path: "verifier_reports",
            name: "verifier_reports",
            title: "Верификаторы",
            component: () =>
              import("../views/manage/Reports/VerifiersReportsList.vue"),
            meta: { requiresAuth: true, scopes: ["admin"] },
          },
          {
            path: "verified_reports",
            name: "verified_reports",
            title: "Верифицированные файлы",
            component: () =>
              import("../views/manage/Reports/VerifiedFilesReportsList.vue"),
            meta: { requiresAuth: true, scopes: ["admin"] },
          },
          {
            path: "dictionary_reports",
            name: "dictionary_reports",
            title: "Словарь",
            component: () =>
              import("../views/manage/Reports/DictionaryReportsList.vue"),
            meta: { requiresAuth: true, scopes: ["admin"] },
          },
        ],
      },
    ],
  },
  {
    path: "/files",
    name: "files",
    component: () =>
      import(/* webpackChunkName: "files" */ "../views/files/index.vue"),
    redirect: { name: "files-list", params: { state: "all" } },
    meta: { requiresAuth: true, scopes: ["admin"] },

    children: [
      {
        path: ":state",
        name: "files-list",
        component: () =>
          import(
            /* webpackChunkName: "files-list" */ "../views/files/FilesList.vue"
          ),
        props: true,
        meta: { requiresAuth: true, scopes: ["admin"] },
      },
      {
        path: ":state/:fileId",
        name: "file-view",
        component: () =>
          import(
            /* webpackChunkName: "file-view" */ "../views/files/FileViewFull.vue"
          ),
        props: true,
        meta: { requiresAuth: true, scopes: ["admin"] },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

const localStorageService = LocalStorageService.getService();

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (localStorageService.getAccessToken() == null) {
      next({
        path: "/auth",
        params: { nextUrl: to.fullPath },
      });
    }
    next();
  } else {
    next();
  }
});

export default router;
